export default {
  computed: {
    pendingDepositDetails () {
      if (
        this.$store.state.transactions.transactions &&
        this.$store.state.transactions.transactions.items
      ) {
        const latestTransaction =
          this.$store.state.transactions.transactions.items
        if (latestTransaction.length > 0) {
          const pendingDeposit = latestTransaction.filter(
            (transaction) =>
              transaction.status === this.$STATUS.PENDING &&
              transaction.type === this.$transactionType.DEPOSIT &&
              transaction.transactionType === this.$transactionType.DEPOSIT
          )
          if (pendingDeposit.length > 0) {
            return pendingDeposit[0]
          }
        }
      }
      return {}
    },
    hasPendingDeposit () {
      return this.$store.state.transactions.transactions.attributes
        .hasPendingLocalDeposits
    },
    pendingPlaidDeposit () {
      const transactions = this.$store.state.transactions.transactions.items
      const transaction = transactions.find(
        (transaction) =>
          transaction.status === this.$STATUS.IN_PROGRESS ||
          (transaction.status === this.$STATUS.PENDING &&
            transaction.method === 'ach')
      )
      return !!transaction
    }
  },
  methods: {
    async getPendingFiatDeposits () {
      this.isLoading = true
      const vm = this
      const payload = {
        page: 1,
        size: '',
        status: 'pending',
        from: '',
        to: '',
        type: 'deposit'
      }
      await this.$store
        .dispatch('transactions/getTransactions', payload)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
    },
    async getDeposits (payload) {
      const vm = this
      await this.$store
        .dispatch('transactions/getDeposits', payload)
        .then(() => {})
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
    }
  }
}
